(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceDetailController', PaperPriceDetailController);

    PaperPriceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PaperPrice', 'YieldCurveResults'];

    function PaperPriceDetailController($scope, $rootScope, $stateParams, previousState, entity, PaperPrice, YieldCurveResults) {
        var vm = this;

        vm.paperPrice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:paperPriceUpdate', function(event, result) {
            vm.paperPrice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
